/**
 * Format date/time in user's local timezone (without timezone abbreviation)
 * @param isoString - ISO timestamp string (e.g., "2025-01-24T18:10:00.000Z")
 * @returns Formatted string like "01/24/26 3:10 PM" (in user's local timezone)
 */
export function formatDateTimeUserTimezone(isoString: string): string {
  const date = new Date(isoString);

  // Use browser's local timezone automatically (no timeZone specified)
  const options: Intl.DateTimeFormatOptions = {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  };

  const formatter = new Intl.DateTimeFormat('en-US', options);
  const parts = formatter.formatToParts(date);

  const month = parts.find((p) => p.type === 'month')?.value;
  const day = parts.find((p) => p.type === 'day')?.value;
  const year = parts.find((p) => p.type === 'year')?.value;
  const hour = parts.find((p) => p.type === 'hour')?.value;
  const minute = parts.find((p) => p.type === 'minute')?.value;
  const dayPeriod = parts.find((p) => p.type === 'dayPeriod')?.value;

  // Return formatted string without timezone abbreviation
  return `${month}/${day}/${year} ${hour}:${minute} ${dayPeriod}`;
}

/**
 * Format date for whats new display (USA: mm/dd/yy h:mma, e.g. "01/26/26 10:30am")
 */
export function formatWhatsNewDate(date: Date): string {
  const options: Intl.DateTimeFormatOptions = {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  };
  const formatter = new Intl.DateTimeFormat('en-US', options);
  const parts = formatter.formatToParts(date);
  const month = parts.find((p) => p.type === 'month')?.value ?? '';
  const day = parts.find((p) => p.type === 'day')?.value ?? '';
  const year = parts.find((p) => p.type === 'year')?.value ?? '';
  const hour = parts.find((p) => p.type === 'hour')?.value ?? '';
  const minute = parts.find((p) => p.type === 'minute')?.value ?? '';
  const dayPeriod = (parts.find((p) => p.type === 'dayPeriod')?.value ?? '').toLowerCase();
  return `${month}/${day}/${year} ${hour}:${minute}${dayPeriod}`;
}
